import React from 'react';
import { View } from 'react-native';

import { IconDelivery, Text, createMqStyles, tokens } from '@fhs/ui';

const TITLE = 'Delivery Coming Soon';
const BODY =
  "Delivery ordering isn't available here yet. Switch to Pickup to find a restaurant near you.";

/**
 * Static stand-in shown while the Delivery tab is selected. Real delivery in the locator is
 * tracked separately; this ticket only ships the toggle.
 */
export const DeliveryPlaceholder: React.VFC = () => {
  const styles = useDeliveryPlaceholderMqStyles();

  return (
    <View
      style={styles.wrapper}
      testID="store-locator-delivery-placeholder"
      accessibilityLabel={`${TITLE}. ${BODY}`}
    >
      <IconDelivery size={48} color={tokens.colors.$blackOpacity30} />
      <Text.Heading type="two" style={styles.title}>
        {TITLE}
      </Text.Heading>
      <Text.Paragraph size="md" style={styles.body}>
        {BODY}
      </Text.Paragraph>
    </View>
  );
};

const useDeliveryPlaceholderMqStyles = createMqStyles({
  wrapper: {
    $base: {
      alignItems: 'center',
      gap: 8,
      padding: 32,
    },
  },
  title: {
    $base: {
      textAlign: 'center',
    },
  },
  body: {
    $base: {
      color: tokens.colors.$blackOpacity55,
      textAlign: 'center',
    },
  },
});
